import { render, staticRenderFns } from "./BLogComment.vue?vue&type=template&id=7f47c912&scoped=true"
import script from "./BLogComment.vue?vue&type=script&lang=js"
export * from "./BLogComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f47c912",
  null
  
)

export default component.exports